import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import axios from "axios";
import fetchMe from "./utils/fetchMe";
import { loginSuccess } from "./store/authSlice";
import { useDispatch } from "react-redux";
import { useJsApiLoader } from "@react-google-maps/api";
import CompanyProfile from "./components/profile/CompanyProfile";
import Profile from "./components/profile/Profile";
import {
  clearAuthTokens,
  getOperatorAuthError,
  setLoginFlag,
  setAuthErrorMessage,
} from "./utils/operatorAuth";
const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const libraries = ["places"];

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [companyProfile, setCompanyProfile] = useState(false);
  const [companyProfileData, setCompanyProfileData] = useState(null);
  const [showProfile, setShowProfile] = useState(false);
  const dispatch = useDispatch();

  const refreshToken = useCallback(
    async (body) => {
      try {
        const { data, status } = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/jwt/refresh/`,
          body,
        );
        if (status === 200) {
          window.localStorage.setItem("access", data.access);
          if (data.refresh) {
            window.localStorage.setItem("refresh", data.refresh);
          }
          const user = await fetchMe(data.access);
          const authError = getOperatorAuthError(user);

          if (authError) {
            clearAuthTokens();
            setAuthErrorMessage(authError);
            setLoading(false);
            window.location.replace("/login");
            return;
          }

          console.log("user", user);

          // Store profile data for CompanyProfile component
          setCompanyProfileData(user.profile);

          dispatch(loginSuccess(user));
          setLoginFlag();
        }
        setLoading(false);
      } catch (error) {
        clearAuthTokens();
        setLoading(false);
      }
    },
    [dispatch],
  );

  useEffect(() => {
    const access = window.localStorage.getItem("access");
    const refresh = window.localStorage.getItem("refresh");

    if (access && refresh) {
      refreshToken({ refresh });
    } else {
      clearAuthTokens();
      setLoading(false);
    }
  }, [refreshToken]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries,
    language: "ru",
  });

  const updateUser = (user) => {
    dispatch(loginSuccess(user));
  };

  const updateProfile = () => {
    refreshToken({ refresh: window.localStorage.getItem("refresh") });
  };

  const modalClose = () => {
    setCompanyProfile(false);
  };

  console.log("companyProfile", companyProfileData);

  return (
    <AuthContext.Provider
      value={{
        setCompanyProfile,
        updateUser,
        updateProfile,
        setShowProfile,
        showProfile,
        companyProfile,
        companyProfileData,
      }}
    >
      {!loading && isLoaded && children}
      {companyProfile && (
        <CompanyProfile
          updateUser={updateUser}
          closeModal={modalClose}
          showModal={companyProfile}
          profile={companyProfileData}
          setProfile={setCompanyProfileData}
        />
      )}
      {showProfile && (
        <Profile
          updateUser={updateUser}
          closeModal={() => setShowProfile(false)}
          showModal={showProfile}
        />
      )}
    </AuthContext.Provider>
  );
};
